import { AxiosInstance } from "axios";
import { useEffect, useRef, useState } from "react";

export type SubscriptionStatus =
  | "PENDING_PAYMENT"
  | "NEW_USER_TOLERANCE"
  | "SUBSCRIPTION_REQUIRED"
  | undefined;

export function handleSubscriptionStatus(
  response: any,
  callback: (status: SubscriptionStatus) => void,
) {
  const subStatus = response.headers["x-subs-status"];
  if (subStatus) {
    // Atualiza o estado da assinatura com base na resposta
    callback(subStatus);
  }
}

export const useSubscriptionStatus = (api: AxiosInstance) => {
  const requested = useRef(window.location.pathname === "/expired" || false);
  const [subscribed, setSubscribed] = useState<SubscriptionStatus>(undefined);

  async function verify() {
    if (requested.current) return;
    requested.current = true;
    const res = await api.post("/subscription/status");
    console.log("Initial subscription status check:", res.data);
  }

  useEffect(() => {
    try {
      console.log("Setting up subscription status interceptor");
      // Configura o interceptor para capturar as respostas da API
      api.interceptors.response.use(
        (response) => {
          handleSubscriptionStatus(response, setSubscribed);
          return response;
        },
        (error) => {
          handleSubscriptionStatus(error.response, setSubscribed);
          return Promise.reject(error);
        },
      );
    } finally {
      console.log("Subscription status interceptor set up successfully");
    }
    verify();
  }, []);

  return subscribed;
};
